export class Product {
    id: string;
    name: string;
    productCategoryId: string;
    productCategory: string;
    productCateGoryManager: string;
    managerId: string;
    devManagerId: string;
    productType: string;
    targetReq: Target;
    constructor() {
        this.name = "";
        this.productCategoryId = "";
        this.productCategory = "";
        this.productCateGoryManager = "";
        this.managerId = "";
        this.devManagerId = "";
        this.productType = "FLAGSHIP";
        this.targetReq = new Target();
    }

}

export class Target {
    id: string;
    year: string;
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
    june: number;
    july: number;
    august: number;
    september: number;
    october: number;
    november: number;
    december: number;
    constructor() {
        this.year = new Date().getFullYear().toString();
    }
}
